import deLang from 'element-ui/lib/locale/lang/de'
const messages = Object.assign(deLang, {
  el: {
    datepicker: {
      now: 'Jetzt',
      today: 'Heute',
      cancel: 'Abbrechen',
      clear: 'Leeren',
      confirm: 'OK',
      selectDate: 'Datum wählen',
      selectTime: 'Uhrzeit wählen',
      startDate: 'Startdatum',
      startTime: 'Startzeit',
      endDate: 'Enddatum',
      endTime: 'Endzeit',
      prevYear: 'Letztes Jahr',
      nextYear: 'Nächtes Jahr',
      prevMonth: 'Letzter Monat',
      nextMonth: 'Nächster Monat',
      day: 'Tag',
      week: 'Woche',
      month: 'Monat',
      year: '',
      month1: 'Januar',
      month2: 'Februar',
      month3: 'Marsch',
      month4: 'April',
      month5: 'Mai',
      month6: 'Juni',
      month7: 'Juli',
      month8: 'August',
      month9: 'September',
      month10: 'Oktober',
      month11: 'November',
      month12: 'Dezember',
      weeks: {
        sun: 'So',
        mon: 'Mo',
        tue: 'Di',
        wed: 'Mi',
        thu: 'Do',
        fri: 'Fr',
        sat: 'Sa'
      },
      months: {
        jan: 'Jan',
        feb: 'Feb',
        mar: 'Mär',
        apr: 'Apr',
        may: 'Mai',
        jun: 'Jun',
        jul: 'Jul',
        aug: 'Aug',
        sep: 'Sep',
        oct: 'Okt',
        nov: 'Nov',
        dec: 'Dez'
      }
    }
  },
  "banner1": "Die Marke Solplanet ist eine Entwicklung von AISWEI",
  "banner2": "ehemals SMA China",
  "banner3": "Solar für alle",
  "english": "Englisch",
  "polish": "Polnisch",
  "spanish": "Spanisch",
  "turkish": "Türkisch",
  "germany": "Deutsch",
  "french": "Französisch",
  "italian": "Italienisch",
  "systemData1": "System",
  "installationLocation1": "Einbau",
  "customerData1": "Kunde",
  "claimData": "Antrag",
  "shippingAddress1": "Lieferung",
  "customerData": "Kunden-/Klientendaten",
  "customerType": "Anfragetyp",
  "selectCustomer": "Bitte wählen Sie den Anfragetyp",
  "--None--": "--Keine--",
  "Installer": "Installateur",
  "End-customer": "Endbenutzer",
  "Distributor": "Vertriebspartner",
  "EPC": "EPC",
  "Other": "Sonstiges",
  "companyName": "Name des Unternehmens",
  "typeCompanyName": "Bitte geben Sie den Firmennamen ein",
  "contacts": "Name der Kontaktperson",
  "typeContacts": "Bitte geben Sie den Namen der Kontaktperson ein",
  "contactInformation": "Telefonnummer",
  "typeContactInformation": "Bitte geben Sie Ihre Telefonnummer ein",
  "shippingAddress": "Lieferadresse (Bitte beachten Sie, dass diese Adresse im Falle eines Umtauschs als Lieferadresse dient)",
  "country": "Staat/Region",
  "typeCountry": "Bitte geben Sie das Staat /Region ein",
  "province": "Bundesland",
  "typeProvince": "Bitte geben Sie das Bundesland ein",
  "city": "Stadt",
  "typeCity": "Bitte geben Sie die Stadt ein",
  "area": "Straße",
  "typeArea": "Bitte geben Sie die vollständige Adresse ein (bis zur Hausnummer)",
  "contacts01": "Mobiltelefon",
  "typeContacts01": "Bitte geben Sie das Mobiltelefon ein",
  "postCode": "Postleitzahl",
  "typePostCode": "Bitte geben Sie die Postleitzahl ein",
  "email": "E-Mail",
  "typeEmail": "Bitte geben Sie ihre E-mail ein",
  "errorEmail": "Bitten geben Sie eine gültige E-email Adresse ein.",
  "installationLocation": "Installationsort (Lieferadresse verwenden",
  "purchaseDate": "Kaufdatum",
  "typePurchaseDate": "Bitte geben Sie das Kaufdatum ein",
  "installDate": "Installationsdatum",
  "typeInstallDate": "Bitte geben Sie das Installationsdatum ein",
  "faultyDeviceType": "Fehlerhafter Gerätetyp",
  "selectFaultyDeviceType": "Bitte wählen Sie den defekten Gerätetyp aus",
  "faultDate": "Störungsdatum",
  "typeFaultDate": "Bitte geben Sie das Störungsdatum ein",
  "deviceSerialNumber": "Seriennummer des Geräts",
  "typeDeviceSerialNumber": "Bitte geben Sie die Seriennummer des Geräts ein",
  "faultySymptom": "Störungserscheinung",
  "selectFaultySymptom": "Bitte wählen Sie das Störungserscheinung aus",
  "errorDescription": "Detaillierte Fehlerbeschreibung",
  "typeErrorDescription": "Bitte geben Sie eine detaillierte Fehlerbeschreibung ein",
  "purchaseFileId": "Kaufbeleg (Anlage)",
  "purchaseDesc": "Der Kaufbeleg muss den Namen des Kunden, die Installationsadresse, das Wechselrichtermodell und den Nachweis, dass der Kunden bezahlt hat",
  "breakFileId": "Fehlerbescheinigung (Anhang)",
  "breakDesc": "Bitte reichen Sie ein Foto des Fehlerdetails, der Fehlermeldung und des Aufklebers mit der Produktseriennummer ein",
  "upload": "Hochladen",
  "systemData": "Systemdaten (optional)",
  "systemData01": "Ist dies der erste Antrag bei der  Kundenseite?",
  "Yes": "Ja",
  "No": "Nein",
  "Unknown": "Unbekannt",
  "systemData02": "Betriebsstatus anderer Wechselrichter in desselbem Standort",
  "systemData03": "Grund für den früheren Antrag",
  "enterSystemData03": "Bitte geben Sie den Grund für den früheren Antrag an",
  "systemData04": "Fehlerdetails der anderen Wechselrichter am selben Standort",
  "enterSystemData04": "Bitte geben Sie die Fehlerdetails der anderen Wechselrichter am selben Standort ein",
  "systemData05": "Umgebungsbedingungen der Wechselrichterinstallation",
  "systemData0501": "Innen",
  "systemData0502": "Außen (unter dem schattigen Teil des Gebäudes oder unter einer Markise)",
  "systemData0503": "Betriebsstatus anderer Wechselrichter in desselbem Standort",
  "systemData0504": "Über Wasser",
  "systemData0505": "Sonstiges",
  "systemData06": "Umgebungsbedingungen für die Installation von Solarmodulen",
  "systemData0601": "Auf dem Boden",
  "systemData0602": "Auf dem Dach",
  "systemData0603": "Auf der Wasseroberfläche",
  "systemData0604": "Andere",
  "systemData07": "Solarmodul Marke&Modell",
  "typeSystemData07": "Bitte geben Sie Marke und Modell des Solarmoduls ein",
  "systemData08": "PV-Modus",
  "systemData0801": "Unabhängig",
  "systemData0802": "Parallel",
  "pleaseSelect": "Bitte auswählen",
  "add": "Hinzufügen",
  "delete": "Löschen",
  "pv10": "String Solarmodul(Stück)",
  "pv101": "PV1String Solarmodul(Stück)",
  "pv102": "PV2String Solarmodul(Stück)",
  "pv103": "PV3String Solarmodul(Stück)",
  "pv104": "PV4String-Solarmodul(Stück)",
  "circuit01": "Leerlaufspannung(V)",
  "alternatingVoltage": "Wechselspannung",
  "l1l2": "Wechselspannung L1 - L2(V)",
  "l1n": "Wechselspannung L1 - N(V)",
  "l2l3": "Wechselspannung L2 - L3(V)",
  "l2n": "Wechselspannung L2 - N(V)",
  "l1l3": "Wechselspannung L1 - L3(V)",
  "l3n": "Wechselspannung L3 - N(V)",
  "l1pe": "Wechselspannung L1 - PE(V)",
  "l3pe": "Wechselspannung L3 - PE(V)",
  "l2pe": "Wechselspannung L2 - PE(V)",
  "npe": "Wechselspannung N - PE(V)",
  "complaintFileId": "Beilage",
  "activeTip": "Hinweis：Je detailliertere Informationen zur Installation Sie uns zur Verfügung stellen können, desto schneller können wir das Problem identifizieren..",
  "submitBtn": "Abschicken",
  "pleaseType": "Bitte eingeben",
  "submitSuccess": "Erfolgreich abschicken",
  "submitDesc": "Einige erforderliche Felder sind nicht ausgefüllt, bitte senden Sie das Formular nach Bestätigung erneut ab. Wir danken Ihnen!",
  "typeUpload": "Bitte hochladen",
  "resetUpload": "Erneut hochladen",
  "selectErrorMessage": "Bitte wählen Sie eine Fehlermeldung aus",
  "errorMessage": "Sonstiges",
  "MPPT": "MPPT",
  "chinese": "Chinesisch",
  "dutch": "Niederländisch",
  "hungary": "Ungarisch",
  "termswebsite": "https://solplanet.net/privacy/",
  "terms": "Ich bin mit den Solplanet-Bedingungen einverstanden",
  "iagree": "Ich bin mit den Solplanet-Bedingungen einverstanden",
  "language": "Sprache",
  "ptbr": "Portugiesisch (Brasilien)",
  "zhtw": "Traditionelles Chinesisch",
  "documentTitle": "Garantie │Solplanet",
  "validateNumber": "Bitte geben Sie eine ganze Zahl ein"
})
export default messages



// WEBPACK FOOTER //
// ./src/widgets/i18n/germany.js